import { useEffect, useState } from 'react';
import { IConfig } from '../../../../interface/game';
import { AframeListener } from '../js/aframeListener';
import { renderARElements } from '../../../../helper/ar';
import MarkerLessSceneInit from './MarkerLessSceneInit';
import { loadScript } from '../../../../util/script';
import ARCaptureBtn from '@/component/common/Button/ARCaptureBtn/ARCaptureBtn';
import { gameCategory } from '@/constants/game';
import GameTimer from '../GameTimer';

const scripts = [
  {
    uri: 'https://aframe.io/releases/1.7.1/aframe.min.js',
  },
  {
    uri: 'https://cdn.jsdelivr.net/gh/c-frame/aframe-extras@7.4.0/dist/aframe-extras.min.js',
  },
  // {
  //   uri: 'https://raw.githack.com/AR-js-org/AR.js/master/aframe/build/aframe-ar.js',
  // },
];
type MarkerlessContentProps = {
  config?: IConfig;
};
const MarkerlessContent = ({ config }: MarkerlessContentProps) => {
  const [isAframeListenerLoaded, setIsAframeListenerLoaded] = useState(false);
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  const renderElements = () => {
    const elements = config?.elements || [];
    renderARElements(elements, undefined, gameCategory.MARKERLESS);
  };

  const onLoadScripts = async () => {
    for (const item of scripts) {
      await loadScript(item.uri);
    }
    setScriptLoaded(true);
  };
  useEffect(() => {
    onLoadScripts();
    if (!isScriptLoaded) return;
    if (isAframeListenerLoaded) {
      const scene: any = document.querySelector('a-scene');
      if (scene && scene.hasLoaded) {
        renderElements();
      } else if (scene) {
        scene.addEventListener('loaded', renderElements);
      }
    }
    if (!isAframeListenerLoaded) {
      new AframeListener();
      setIsAframeListenerLoaded(true);
    }
  }, [isAframeListenerLoaded, isScriptLoaded]);

  if (!isAframeListenerLoaded) return <></>;
  return (
    <section id="markerless" className="relative w-full h-full">
      <MarkerLessSceneInit />
      <ARCaptureBtn videoId="webcam" />
      <GameTimer timer={config?.timer} />
    </section>
  );
};

export default MarkerlessContent;
